import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Label } from '@/store/models/label';
import { ULID } from '@/store/models';
import LabelChip from '@/components/Label/Chip';
import { t } from '@/i18n/i18n';
import template from './FinderBase.vue';

@Component({
	mixins: [template],
	components: {
		LabelChip
	}
})
export default class FinderBase extends Vue {
	@Prop({ type: String, default: 'width: 376px; max-width: 100%;' }) styleP: string;

	@Prop({ type: String, default: '' }) placeholder: string;

	@Prop({ type: String, default: '' }) label: string;

	@Prop({ type: Boolean, default: false }) loading: boolean;

	@Prop({ default: [] }) items: Label[];

	@Prop({
		default(): (search: string) => Promise<void> {
			// eslint-disable-next-line no-empty-function
			return async function(_search): Promise<void> {};
		}
	})
	search: (search: string) => Promise<void>;

	@Prop({ type: String, default: t('general.no-labels-found') }) noDataText: string;

	@Prop({ type: String, default: t('general.filter-by-label') }) hint: string;

	@Prop({ type: String, default: '' }) prependInnerIcon: string;

	@Prop({ type: Boolean, default: false }) persistence: boolean;

	@Prop({
		default(): () => void {
			return function(): void {};
		}
	})
	blur: () => void;

	@Prop() error!: any;

	keyWord: string = '';

	selected: Label[] = [];

	async mounted(): Promise<void> {
		await this.search('');
	}

	// Auto-complete methods
	isCurrentlySelected(id: ULID): boolean {
		for (let i = 0; i < this.selected.length; i++) {
			if (this.selected[i].id === id) return true;
		}
		return false;
	}

	addChip(id: Label) {
		this.selected.push(id);
	}

	removeChip(index: number) {
		this.selected.splice(index, 1);
	}

	@Watch('selected')
	onChangeSelected(): void {
		this.$emit('update-selected', this.selected);
	}

	@Watch('items')
	onChange(): void {
		this.selected.forEach((element) => {
			if (!this.items.includes(element)) {
				this.items.push(element);
			}
		});
	}

	clear(): void {
		this.selected.splice(0, this.selected.length);
	}

	doSearch(keyWord: string): Promise<void> {
		return this.search(keyWord);
	}

	onBlur(): void {
		this.search('');
		this.blur();
	}
}
